<template lang="pug">
v-app
  v-overlay(:value="signInWithTokenLoading")
    v-progress-circular(indeterminate size="64")

  v-container.pt-6.pl-2.pr-6
    .d-flex.justify-space-between
      v-btn(icon :large="isLarge" :style="step === 'ONBOARDING' ? 'opacity: 0' : ''" :disabled="signInWithPhoneNumberLoading" @click="back()")
        v-icon mdi-arrow-left
      .d-flex.align-center
        v-btn.plain-btn.mr-8.text-body-3.text-md-h3(@click="callCenter()")
          v-icon(:size="isLarge ? 30 : 20") mdi-phone
        v-btn.plain-btn.mr-4.mr-md-6.text-body-3.text-md-h3(@click="switchLocale('kk')" :disabled="locale === 'kk'") Қаз
        v-btn.plain-btn.text-body-3.text-md-h3(@click="switchLocale('ru')" :disabled="locale === 'ru'") Рус

  v-main

    v-container(fill-height).max-width
      v-img.left-image.d-none.d-md-block(src="/static/icons/left-shape.svg")

      // --------------------------------------------------------------------------------------------
      template(v-if="step === 'ONBOARDING'")
        .d-flex.flex-column.justify-space-between.fill-height
          v-window(v-model="onboardingStep")
            v-window-item(v-for="(slide, index) in onboardingSlides" :key="`card-${index}`" eager)
              img(:src="`/static/${slide.image}.png`" style="max-width: 400px; width: 100%;")
              p(v-dompurify-html="slide.title").font-weight-bold.text-h3.text-center.mb-5
              p(v-dompurify-html="slide.text").text-subtitle-1.text-center
          v-card-actions.justify-space-between.pb-10
            v-btn(color="reForeground" :disabled="onboardingStep === 0" min-width="96" elevation="0" @click="onboardingPrev").font-weight-bold.text-subtitle-1 {{ $t("назад") }}
            v-item-group(v-model="onboardingStep" mandatory).text-center
              v-item(v-for="n in onboardingSlides.length" :key="`btn-${n}`" v-slot="{ active, toggle }")
                v-btn(:input-value="active" icon width="16" height="16" :color="active ? 'primary' : 'reBackground darken-1'" @click="toggle")
                  v-icon mdi-circle-medium
            v-btn(color="primary" min-width="96" elevation="0" @click="onboardingNext").font-weight-bold.text-subtitle-1 {{ $t("далее") }}

      // --------------------------------------------------------------------------------------------
      template(v-if="step === 'ENTER_PHONE_NUMBER'")
        .d-flex.flex-column.align-self-start
          v-form(@submit.prevent="signIn()")
            p.text-h3.font-weight-bold.text-md-h2.pt-6.pt-md-15 {{ $t("введите_номер_телефона") }}
            p.mt-8.mb-2.text-body-1.text-md-subtitle-1 {{ $t("номер_телефона") }}
            v-text-field.rounded-xl(
                    ref="phoneNumber"
                    v-model="phoneNumber"
                    v-mask="'+7 (###) ###-##-##'"
                    type="tel"
                    placeholder="+7 (###) ###-##-##"
                    :disabled="signInWithPhoneNumberLoading"
                    autocomplete="off"
                    @input="phoneNumberError = null"
                    :error-messages="phoneNumberError"
                    :hint="$t('отправим_код_подтверждения')"
                    persistent-hint
                    filled)
            re-turnstile.mt-3(ref="turnstile" @verified="turnstileToken = $event" @expired="turnstileToken = null" @error="turnstileToken = null")
            v-btn.font-weight-bold.text-h5.text-md-h4.mt-3(:large="isLarge" :disabled="!phoneNumber || phoneNumber.length !== 18 || !turnstileToken" block color="primary" type="submit" :loading="signInWithPhoneNumberLoading" @click.prevent="sendCode()") {{ $t("продолжить") }}
          p.text-center.text-body-1.mt-6.text-md-subtitle-1.additional--text {{ $t("нажимая_кнопку_продолжить_вы_принимаете_условия") }} &nbsp;
            a(@click="$openLink(`https://link.rekassa.kz/app-agreement${locale === 'ru' ? '' : '-kk'}`, '_system')") {{ $t("пользовательского_соглашения") }}

      // --------------------------------------------------------------------------------------------
      template(v-if="step === 'ENTER_CONFIRMATION_CODE'")
        .d-flex.flex-column.align-self-start.re-fill-width
          p.text-h3.font-weight-bold.text-md-h2.text-center.pt-6.pt-md-15 {{ $t("мы_отправили_код_в_sms") }}
          p.text-center.text-subtitle-2.text-md-h5.mt-6.mt-md-12.mb-6 {{ $t("значный_код_отправлен_по_номеру") }}
            br
            | {{ phoneNumber }}
          re-otp-input.px-3.my-0(v-model="confirmationCode" :error.sync="confirmationCodeError" :disabled="signInLoading" @action="verifyCode")
          v-col.py-1(cols="12" align="center")
            v-btn.text-md-h5.text-center.mt-3(text color="secondary" :disabled="confirmationCodeCounter > 0"  @click.prevent="signInWithAlternativesBottomSheet = true; analyticsLogEvent({ eventName: 're_auth_user_requested_alternative_confimation' })") {{ $t("не_пришел_код") }} ({{ confirmationCodeTimeLeft }})
          v-btn.font-weight-bold.text-h5.text-md-h4.mt-5(:disabled="!(confirmationCode && confirmationCode.length === 6)" color="primary" block :large="isLarge" type="submit" :loading="signInLoading" @click.prevent="verifyCode()") {{ $t("продолжить") }}

      v-img.right-image.d-none.d-md-block(src="/static/icons/right-shape.svg")

  v-bottom-sheet(v-model="signInWithAlternativesBottomSheet" inset width="400")
    v-sheet.rounded-t-lg
      v-card.rounded-t-lg
        v-card-title.pb-0
          v-row
            v-col.pr-0.align-self-center(cols="10")
              span.headline {{ $t("попробуйте_войти_другим_способом") }}
            v-col.pl-0(cols="2" align="right")
              v-btn(icon @click="signInWithAlternativesBottomSheet = false")
                v-icon mdi-close
        v-card-text.px-0
          v-container.px-2
            v-col(cols="12")
              v-btn(block color="blue" @click="signInWithAlternativesBottomSheet = false; signInWithTelegram()")
                v-icon(small left) mdi-send
                | {{ $t("войти_через_telegram") }}

  re-connection-warning
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale, changeLocale } from '../../i18n'
import ConnectionWarning from '../utils/ConnectionWarning.vue'
import OTPInput from '../utils/OTPInput.vue'
import Turnstile from '../utils/Turnstile.vue'

export default {
  components: {
    're-connection-warning': ConnectionWarning,
    're-otp-input': OTPInput,
    're-turnstile': Turnstile,
  },

  data: () => ({
    step: (localStorage.getItem('rekassa.kz-auth-onboarding-seen') || 'false') === 'true' ? 'ENTER_PHONE_NUMBER' : 'ONBOARDING',

    phoneNumber: null,
    phoneNumberError: null,

    otpPhone: null,
    otpHash: null,

    confirmationCode: null,
    confirmationCodeTimeLeft: null,
    confirmationCodeCounter: null,
    confirmationCodeTimer: null,
    confirmationCodeError: null,

    turnstileToken: null,

    signInWithTokenLoading: false,

    signInWithPhoneNumberLoading: false,
    signInLoading: false,

    signInWithAlternativesBottomSheet: false,

    rules: {
      required: v => !!v || this.$t('требуется_заполнить'),
    },

    onboardingStep: 0,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),

    locale() {
      return getLocale()
    },

    isLarge() {
      return this.$vuetify.breakpoint.mdAndUp
    },

    onboardingSlides() {
      return [
        {
          title: this.$t('ведите_весь_бизнес_в_одном_приложении'),
          text: this.$t('да_представьте_rekassa_это_возможно'),
          image: 'onboarding1',
        },
        {
          title: this.$t('управляйте_ассортиментом'),
          text: this.$t('создавайте_списки_и_категории_товаров_чтобы_выбивать_чеки_быстрее_и_удобнее'),
          image: 'onboarding2',
        },
        {
          title: this.$t('принимайте_платежи'),
          text: this.$t('выбирайте_удобный_способ_наличными_картой_переводом_rekassa_принимает_все'),
          image: 'onboarding3',
        },
        {
          title: this.$t('пробивайте_чеки'),
          text: this.$t('фискализируйте_продажи_вручную_или_автоматически_а_rekassa_доставит_их_в_налоговую'),
          image: 'onboarding4',
        },
        {
          title: this.$t('хорошая_идея_это_уже_половина_дела'),
          text: this.$t('пройдите_регистрацию_чтобы_начать_прямо_сейчас'),
          image: 'onboarding5',
        },
      ]
    },
  },

  watch: {
    '$route.query.token': {
      async handler(token) {
        if (token) {
          this.signInWithTokenLoading = true

          // Impersonate: если уже есть активная сессия - сначала полный signOut,
          // чтобы отписать пуши старого пользователя и сбросить appInitialized
          // (иначе новый пользователь не подпишется на пуши, а старому продолжат приходить)
          if (await this.hasActiveSession()) {
            await this.signOut({ redirect: false })
          }

          this.signInWithCustomToken({ token }).then((tokenResult) => {
            this.setUser(tokenResult.user).then(() => {
              this.init().then(() => {
                this.analyticsLogEvent({ eventName: 'login', eventProperties: { type: 'Token' } })
                this.$router.push({
                  path: '/',
                  query: this.$route.query,
                })
              })
            })
          }).catch((error) => {
            this.signInWithTokenLoading = false
            this.signInLoading = false
            if ((error && error.code === 'auth/user-disabled') || error === 'The user account has been disabled by an administrator.') {
              this.showConfirm({
                title: this.$t('пользователь_заблокирован'),
                text: this.$t('обратитесь_в_службу_поддержки_чтобы_узнать_причину_блокировки'),
                resolveText: this.$t('позвонить_в_службу_поддержки'),
                rejectText: this.$t('закрыть'),
              }).then(() => {
                this.$openLink('tel:+77777779449', '_system')
              }).catch(() => {})
            } else {
              this.showSnackbar({ message: this.$t('не_удалось_войти_по_токену') })
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    // При входе по токену (impersonate) не уводим на главную старого пользователя
    if (this.user && !this.$route.query.token) {
      this.$router.push('/')
    }

    if (this.step === 'ENTER_PHONE_NUMBER') {
      this.preparePhoneNumber()
    }
  },

  beforeDestroy() {
    // Восстановить тему
    const darkTheme = localStorage.getItem('rekassa.kz-ui-theme') === 'dark'
    this.$vuetify.theme.dark = darkTheme
  },

  methods: {
    ...mapActions({
      sendOtp: 'auth/sendOtp',
      verifyOtp: 'auth/verifyOtp',
      signInWithCustomToken: 'auth/signInWithCustomToken',
      hasActiveSession: 'auth/hasActiveSession',
      signOut: 'auth/signOut',
      setUser: 'auth/setUser',
      init: 'cashRegisters/init',
      setConnectionWarning: 'tools/setConnectionWarning',
      showConfirm: 'confirm/showConfirm',
      showSnackbar: 'tools/showSnackbar',
      firebaseRemoteConfigGetString: 'tools/firebaseRemoteConfigGetString',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    preparePhoneNumber() {
      this.phoneNumber = localStorage.getItem('rekassa.kz-auth-last-phone-number')
      if (this.confirmationCodeTimer) {
        clearInterval(this.confirmationCodeTimer)
      }
      this.$nextTick(() => {
        // К моменту nextTick пользователь мог уйти с экрана (редирект после разлогина)
        if (this.$refs.phoneNumber) {
          this.$refs.phoneNumber.focus()
        }
      })
    },

    onboardingNext() {
      if (this.onboardingStep + 1 === this.onboardingSlides.length) {
        localStorage.setItem('rekassa.kz-auth-onboarding-seen', 'true')
        this.step = 'ENTER_PHONE_NUMBER'
        this.preparePhoneNumber()
      } else {
        this.onboardingStep += 1
      }
    },

    onboardingPrev() {
      if (this.onboardingStep - 1 >= 0) {
        this.onboardingStep -= 1
      }
    },

    back() {
      this.confirmationCodeError = null
      this.phoneNumberError = null
      this.step = this.step === 'ENTER_PHONE_NUMBER' ? 'ONBOARDING' : 'ENTER_PHONE_NUMBER'

      if (this.step === 'ENTER_PHONE_NUMBER') {
        this.preparePhoneNumber()
      }
    },

    callCenter() {
      document.location.href = 'tel:+77777779449'
      this.analyticsLogEvent({ eventName: 're_auth_call_button_click' })
    },

    signInWithTelegram() {
      this.$openLink(`https://t.me/${import.meta.env.VITE_TELEGRAM_BOT_NAME}`, '_system')
      this.analyticsLogEvent({ eventName: 're_auth_auth_telegram_button_click' })
    },

    sendCode() {
      this.analyticsLogEvent({ eventName: 're_auth_user_filled_phone_number' })

      this.signInWithPhoneNumberLoading = true
      this.otpPhone = `+${this.phoneNumber.replace(/[^\d]/g, '')}`

      this.sendOtp({ data: { phone: this.otpPhone, token: this.turnstileToken } }).then(result => {
        this.otpHash = result.hash
        this.step = 'ENTER_CONFIRMATION_CODE'
        this.signInWithPhoneNumberLoading = false

        // Countdown
        this.confirmationCodeTimeLeft = '0:25'
        this.confirmationCodeCounter = 25
        this.confirmationCodeTimer = setInterval(() => {
          if (this.confirmationCodeCounter <= 0) {
            clearInterval(this.confirmationCodeTimer)
          } else {
            this.confirmationCodeCounter -= 1
            this.confirmationCodeTimeLeft = `0:${this.$options.filters.numeral(this.confirmationCodeCounter, '00')}`
          }
        }, 1000)
      }).catch((error) => {
        // Contract from sms-auth (/sms/send-otp): WRONG_PHONE/TOO_MANY_REQUESTS are user-fixable;
        // provider rejected or unreachable -> 400 { code: 'ERROR' }; no response == client offline;
        // 5xx without code == backend/gateway down. The last three are treated as a provider outage.
        const status = error.response && error.response.status
        const code = error.response && error.response.data && error.response.data.code
        if (code === 'WRONG_TOKEN') {
          this.turnstileToken = null
          if (this.$refs.turnstile) {
            this.$refs.turnstile.reset()
          }
          this.showSnackbar({ message: this.$t('sms/WRONG_TOKEN') })
        } else if (!error.response || code === 'ERROR' || status >= 500) {
          this.showSmsProviderUnavailable()
        } else if (code) {
          this.phoneNumberError = this.$t(`sms/${code}`)
        } else {
          this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
        }
        this.signInWithPhoneNumberLoading = false
      })
    },

    showSmsProviderUnavailable() {
      this.analyticsLogEvent({ eventName: 're_auth_sms_provider_unavailable' })
      this.showConfirm({
        title: this.$t('проблема_с_отправкой_sms'),
        text: this.$t('проблема_на_стороне_sms_провайдера'),
        resolveText: this.$t('войти_через_telegram'),
        rejectText: this.$t('закрыть'),
      }).then(() => {
        this.signInWithTelegram()
      }).catch(() => {})
    },

    verifyCode() {
      this.analyticsLogEvent({ eventName: 're_auth_user_entered_confirmation_code' })
      this.signInLoading = true
      this.verifyOtp({ data: { phone: this.otpPhone, hash: this.otpHash, otp: this.confirmationCode } }).then(result => {
        this.signInWithCustomToken({ token: result.token }).then((tokenResult) => {
          this.setUser(tokenResult.user).then(() => {
            this.init().then(() => {
              this.analyticsLogEvent({ eventName: 'login', eventProperties: { type: 'Kazinfotech' } })
              if (this.$route.query.from && !this.$route.query.from.includes('signin')) {
                this.$router.push(this.$route.query.from, () => {})
              } else {
                this.$router.push('/', () => {})
              }
              localStorage.setItem('rekassa.kz-auth-last-phone-number', this.phoneNumber)
            })
          })
        }).catch((error) => {
          this.signInLoading = false
          if ((error && error.code === 'auth/user-disabled') || error === 'The user account has been disabled by an administrator.') {
            this.step = 'ENTER_PHONE_NUMBER'
            this.showConfirm({
              title: this.$t('пользователь_заблокирован'),
              text: this.$t('обратитесь_в_службу_поддержки_чтобы_узнать_причину_блокировки'),
              resolveText: this.$t('позвонить_в_службу_поддержки'),
              rejectText: this.$t('закрыть'),
            }).then(() => {
              this.$openLink('tel:+77777779449', '_system')
            }).catch(() => {})
          } else {
            this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
          }
        })
      }).catch((error) => {
        // Contract from sms-auth (/sms/verify-otp): WRONG_OTP/OTP_EXPIRED/WRONG_REQUEST/TOO_MANY_REQUESTS
        // are user-fixable (shown inline, even OTP_EXPIRED which carries HTTP 504). Firebase failure
        // -> 500 { code: 'ERROR' }, no response == client offline, other 5xx == outage -> retry dialog.
        const status = error.response && error.response.status
        const code = error.response && error.response.data && error.response.data.code
        if (code && code !== 'ERROR') {
          this.confirmationCodeError = this.$t(`sms/${code}`)
        } else if (!error.response || code === 'ERROR' || status >= 500) {
          this.showSmsProviderUnavailable()
        } else {
          this.showSnackbar({ message: `${this.$t('произошла_ошибка')}: ${error}` })
        }
        this.signInLoading = false
      })
    },

    switchLocale(locale) {
      changeLocale(locale)
    },
  },
}
</script>
<style lang="stylus" scoped>
.plain-btn
  background-color transparent !important
  opacity 1 !important
  box-shadow none !important
  text-transform none !important
  color inherit !important
  padding 0 !important
  &:hover
    background transparent !important
    opacity 1 !important

  @media (max-width 960px) {
    min-width 40px !important
    height 40px !important
  }

.max-width
  max-width 440px !important

.left-image
  position fixed
  width 300px
  height 470px
  left -5px
  top 50%
  margin-top -235px

.right-image
  position fixed
  width 300px
  height 470px
  right -5px
  top 50%
  margin-top -235px

.bottom-sheet
  border-radius 20px 20px 0px 0px
</style>
